import { Authentication } from "../auth/Authentication";
import { ContentView } from "../view/ContentView";
import { ShareEmailView } from "./email/ShareEmailView";
import { ConversionUtils } from "../utils/ConversionUtils";
import { BrowserUtils } from "../utils/BrowserUtils";
import { WarningWindow } from "../ui/WarningWindow";
import { XHRLoader } from "../utils/XHRLoader";
import { Project } from "../auth/Project";

export class SharingManager
{
	private _auth : Authentication;
	private _content : ContentView;
	private _img : HTMLImageElement;

	private _shareEmailView: ShareEmailView;

	constructor(auth?:Authentication)
	{
		//this._content = content;
		//this._img = <HTMLImageElement>document.getElementById("preview");
		//this._img.src = "http://viral3d.com/mueller/dev_09_19/3D-canvas-1200x630.jpg";
		//this.init();

		this._auth = auth;
		this._shareEmailView = new ShareEmailView("email_popup");

		var share_facebook = document.getElementById("share_facebook");
		share_facebook.addEventListener("click", this.onShareFacebook);

		var share_google = document.getElementById("share_google");
		share_google.addEventListener("click", this.onShareGoogle);

		var share_twitter = document.getElementById("share_twitter");
		share_twitter.addEventListener("click", this.onShareTwitter);

		var share_pinterest = document.getElementById("share_pinterest");
		share_pinterest.addEventListener("click", this.onSharePinterest);

		var share_email = document.getElementById("share_email");
		share_email.addEventListener("click", this.onShareEmail);
	}

	/**
	 * Things to consider:
	 * - facebook uses opengraph to crawl data when accessing the sharer url, sharer only cares about
	 *   the url passed and retrieves image, description, etc through that url
	 * - the crawler doesn't execute javascript, dynamic content can only be generated via php (/server)
	 * - caching can be disabled by using a timestamp in the query (both here in the url and in
	 *   og meta tags (url and image)
	 */
	public onShareFacebook = async () =>
	{
		await this.showWarning();

		const date = this._auth.selectedProject.date;

		if (date)
		{
			const url = 'https://www.facebook.com/sharer.php?u=' + (await this.getPageUrl());

			this.openPopUp(url);

			await this.insertShareEventToDB("Facebook");
		}
	};

	public onShareGoogle = async () =>
	{
		await this.showWarning();

		const date = this._auth.selectedProject.date;

		if (date)
		{
			const url = 'https://plus.google.com/share?url=' + (await this.getPageUrl());

			this.openPopUp(url);

			await this.insertShareEventToDB("Google");
		}
	};

	public onShareTwitter = async () =>
	{
		await this.showWarning();

		const date = this._auth.selectedProject.date;

		if (date)
		{
			const url = 'https://twitter.com/share?url=' + (await this.getPageUrl(false)) + "&text=Nice Mueller 3D design project:&hashtags=muellerinc,metalroofing,steelbuilding";

			this.openPopUp(url);

			await this.insertShareEventToDB("Twitter");
		}
	};

	public onSharePinterest = async () =>
	{
		await this.showWarning();

		const date = this._auth.selectedProject.date;

		if (date)
		{
			const image_url = `${BrowserUtils.getURLPathWithoutQuery()}images/${this._auth.selectedProject.id}.jpg`;

			const url = 'https://www.pinterest.com/pin/create/button/?url=' + (await this.getPageUrl(false)) + `&media=${image_url}&description=Mueller%203D%20Building%20Design%20Project`;
			this.openPopUp(url);

			await this.insertShareEventToDB("Pinterest");
		}
	};

	public onShareEmail = async () =>
	{
		await this.showWarning();

		const defaultMessage = "\n\n" + (await this.getPageUrl(false, false));

		//if (defaultMessage !== "\n\nhttps://apps.muellerinc.com/design/")
		if (defaultMessage.includes("project"))
		{
			this._shareEmailView.show(defaultMessage);
		}
	};

	private insertShareEventToDB(platform: string)
	{
		return new Promise<boolean>((resolve, reject) =>
		{
			const xhr = XHRLoader.load({
				url: Authentication.URL + "insert_to_share_table.php",
				method: XHRLoader.METHOD_GET,
				json: false,
				params: {
					email: this._auth.email,
					platform: platform,
					projectLink: window.location.href,
				},
				onComplete: async (xhr, result, params) =>
				{
					console.log("Share event inserted into db");
					resolve(true);
				},
				onFail: async () =>
				{
					console.log("Error while inserting share event into db");
					resolve(false)
				}
			});
		});
	}

	private async showWarning()
	{
		if (!this._auth.loggedIn)
		{
			await WarningWindow.open(`Please first sign in to your Mueller account to be able to share your project.`);
			return true;
		}

		if (!this._auth.isSelectedProjectSaved())
		{
			await WarningWindow.open(`Please save your Mueller project in order to share the most current version.`);
			return true;
		}

		return false;
	}

	private getShareEmailAndProjectName()
	{
		return new Promise<{email: string, projectName: string}>((resolve, reject) =>
		{
			var xhr = XHRLoader.load({
				url: Authentication.URL + "get_share_project.php",
				method: XHRLoader.METHOD_GET,
				params: {
					email: this._auth.email,
					project_name: this._auth.selectedProject.name
				},
				onComplete: async (xhr, result, params) =>
				{
					let project = null;
					if (!result.error && Array.isArray(result.message))
					{
						project = result.message[0];
					}

					if (project)
					{
						const project = new Project(result.message[0]);

						resolve({
							email: "0", // constants for shared links
							projectName: project.name
						});
					}
					else
					{
						await WarningWindow.open(`The project could not be loaded. Please proceed with a new project.`);
						resolve(null);
					}
				},
				onFail: async () =>
				{
					await WarningWindow.open("Share link couldn't be created. Please try again.");
					resolve(null);
				}
			});
		});
	}

	public async getPageUrl(addRandomTime = true, encode = true)
	{
		//
		// - if user has a project selected -> share that project
		// - if user has no projects selected but has a url with a project -> share that project
		// - otherwise share the default mueller site
		//

		var base_url = BrowserUtils.getURLPathWithoutQuery();
		var url = base_url;

		var randomTime = "";
		var andRandomTime = "";
		if (addRandomTime)
		{
			randomTime = "t=" + new Date().getTime();
			andRandomTime = "&" + randomTime;
		}

		if (this._auth.email && !this._auth.isCurrentProjectInitial())
		{
			const shareData = await this.getShareEmailAndProjectName();

			if (shareData)
			{
				var queryString = ConversionUtils.buildQueryString(
					["email", shareData.email,
					 "project", shareData.projectName,
					],
					"?"
				);
				url = base_url + queryString + andRandomTime;
			}
		}
		else
		{
			var projectInfoFromURL = Authentication.getProjectInfoFromURL();

			if (projectInfoFromURL)
			{
				var queryString = ConversionUtils.buildQueryString(
					["email", projectInfoFromURL.email,
					 "project", projectInfoFromURL.project,
					],
					"?"
				);
				url = base_url + queryString + andRandomTime;
			}
			else
			{
				// prevent default image from caching
				if (randomTime)
				{
					url = url + "?" + randomTime;
				}
			}
		}

		if (encode)
		{
			url = encodeURIComponent(url);
		}

		if (url.indexOf("apps") === -1)
		{
			url = url.replace("muellerinc", "apps.muellerinc");
		}

		if (url.indexOf("www") > -1)
		{
			url = url.replace("www.apps", "apps");
		}

		return url;
	}

	private async openPopUp(url:string)
	{
		var winWidth = 600;
		var winHeight = 380;

		var winTop = (screen.height / 2) - (winHeight / 2);
		var winLeft = (screen.width / 2) - (winWidth / 2);

		if (url.indexOf("twitter") > -1) {
			await WarningWindow.open(`You may need to close the share window and share again to pick up the building image in Twitter.<br/><br/>Click OK to continue share to Twitter.`);
			}
		var sharewindow = await window.open(url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
	}

	public sleep(milliseconds) {
	  const date = Date.now();
	  let currentDate = null;
	  do {
		currentDate = Date.now();
	  } while (currentDate - date < milliseconds);
	}
}